import AxiosConfig from '@/config/axios-config'

export const CategoriaCursosAPI = {

  listarDisciplinas () {
    return AxiosConfig.secureJalekoAPI().get('/admin/disciplinas').then(response => response.data)
  },

  listarCategorias () {
    return AxiosConfig.secureJalekoAPI().get('/admin/categorias').then(response => response.data)
  },

  listarSistemas () {
    return AxiosConfig.secureJalekoAPI().get('/admin/sistemas').then(response => response.data)
  },

  listarPlanos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/planosMacro').then(response => response.data.planosMacros)
  },

  salvarCategorias (categoria) {
    let formData = new FormData()
    for (var key in categoria) {
      formData.append(key, categoria[key])
    }
    return AxiosConfig.secureJalekoAPI().post('/admin/categorias', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  editarCategorias (categoria) {
    let formData = new FormData()
    for (var key in categoria) {
      formData.append(key, categoria[key])
    }
    return AxiosConfig.secureJalekoAPI().post('/admin/categorias/' + categoria.id, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  excluirCategorias (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/categorias/${id}`).then(response => response.data)
  }

}

export default CategoriaCursosAPI
